<template>
  <page-result :image="image" :title="title" :showHotline="false">
    <div class="btn" @click="toNextPage()">去支付</div>
  </page-result>
</template>

<script>
import PageResult from '@/components/PageResult';
import imgSuccess from '@/assets/img-status-success.png';
import { bindRecord } from '@/core/recorder';

export default {
  name: 'CertifyResult',
  components: {
    PageResult,
  },
  data() {
    return {
      image: imgSuccess,
      title: '投保单已签署成功',
    };
  },
  created() {
    const { businessNo, mobile } = this.$route.query;
    if (businessNo && mobile) {
      bindRecord({ userId: businessNo + '_' + mobile });
    }
  },
  methods: {
    toNextPage() {
      const {
        checkMessageFlag,
        realAuthSmsFlag,
        businessNo,
        mobile,
      } = this.$route.query;
      if (Number(checkMessageFlag)) {
        this.$router.replace({
          path: '/proposal-auth',
          query: { businessNo, mobile, type: 'payment' },
        });
      } else if (Number(realAuthSmsFlag)) {
        this.$router.replace({
          path: '/eproposal/sms',
          query: { businessNo, mobile, type: 'payment' },
        });
      } else {
        this.$router.replace({
          path: '/insure-payment',
          query: { businessNo, mobile },
        });
      }
    },
  },
};
</script>

<style lang="less">
.page-result {
  background-color: #ffffff;

  .btn {
    width: 160px;
    height: 44px;
    line-height: 44px;
    border-radius: 4px;
    border: solid 1px #1665d8;
    text-align: center;
    color: #1665d8;
    font-size: 18px;
    margin: 0 auto;
  }
}
</style>
